import React from 'react'
import injectSheet from 'react-jss'
import styles from './icon-holder.styles'
import classNames from 'classnames'

const IconHolder = ({ classes, className, children }) => (
  <span className={classNames(classes.iconHolder, className)}>{children}</span>
)

export default injectSheet(styles)(IconHolder)
